var map = {
	"./DSC_0071.jpeg": 5184,
	"./DSC_1655.jpeg": 5416,
	"./DSC_2072.jpeg": 7532,
	"./DSC_2169.jpeg": 2796,
	"./DSC_2261.jpeg": 9396,
	"./DSC_2264.jpeg": 5712,
	"./DSC_2326.jpeg": 3276,
	"./thumbnail.jpeg": 7236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9440;